import React from 'react';
import { useDecision } from '@walmart-dataventures/feature-flag-sdk-react';

import ActivityTypeCard from '../ActivityTypeCard/index.jsx';
import { IHUT_ACTIVITY_CATEGORY } from '../../constants.js';
import { IHUT_FEATURE_KEY } from '../../../../constants/common.js';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { ihutSelectors } from '../../../../redux/slices/ihut.ts';
import { logger } from '../../../../utils/logger.js';

const IhutActivitiesCard = ({ onClickRow, showProductTestingFeatureIntro }) => {
  const [decision] = useDecision(IHUT_FEATURE_KEY);
  const activities = useAppSelector(ihutSelectors.selectAvailableActivities);
  const activitiesCount = activities?.length || 0;

  if (!decision?.enabled) {
    logger.info(
      'IHUT feature is disabled, not rendering IHUT activities card',
      {
        decision: JSON.stringify(decision),
        activities: JSON.stringify(activities)
      }
    );
    return null;
  }

  if (activitiesCount === 0) return null;

  return (
    <ActivityTypeCard
      data-testid={IHUT_ACTIVITY_CATEGORY.title}
      key={IHUT_ACTIVITY_CATEGORY.title}
      id={IHUT_ACTIVITY_CATEGORY.id}
      optedIn
      title={IHUT_ACTIVITY_CATEGORY.title}
      description={IHUT_ACTIVITY_CATEGORY.description}
      onClick={() => onClickRow({ ...IHUT_ACTIVITY_CATEGORY, optedIn: true })}
      activityCount={activitiesCount}
      showPopover={false}
      showWeeklyQuestFeatureIntro={false}
      popoverTitle=""
      popoverSubTitle=""
      showProductTestingFeatureIntro={showProductTestingFeatureIntro}
    />
  );
};

export default IhutActivitiesCard;
